// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$String = require("rescript/lib/js/string.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var ParticleData$PdgLookup = require("./ParticleData.bs.js");

function makePdgMap(particles) {
  var pdgCodes = Belt_Array.map(particles, (function (p) {
          return p.pdg;
        }));
  return Belt_MapInt.fromArray(Belt_Array.zip(pdgCodes, particles));
}

function makeNameMap(particles) {
  var names = Belt_Array.map(particles, (function (p) {
          return $$String.lowercase_ascii(p.name);
        }));
  return Belt_MapString.fromArray(Belt_Array.zip(names, particles));
}

var particlePdgMap = makePdgMap(ParticleData$PdgLookup.data);

function getWithPDG(pdg) {
  return Belt_MapInt.get(particlePdgMap, pdg);
}

var particleNameMap = makeNameMap(ParticleData$PdgLookup.data);

function getWithName(name) {
  var lowerName = $$String.lowercase_ascii(name);
  var p = Belt_MapString.get(particleNameMap, lowerName);
  if (p !== undefined) {
    return p;
  }
  
}

exports.makePdgMap = makePdgMap;
exports.makeNameMap = makeNameMap;
exports.particlePdgMap = particlePdgMap;
exports.getWithPDG = getWithPDG;
exports.particleNameMap = particleNameMap;
exports.getWithName = getWithName;
/* particlePdgMap Not a pure module */
